import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import Review from "./Review";
import {validateProjectClose, updateProject} from "../../api";
import {confirmAlert} from "react-confirm-alert";
import {withRouter} from "react-router-dom";
import Button from "../../components/Button";
import {Col, Grid, Row} from "react-flexbox-grid";
import Errors from "../../components/Errors";
import ShowCloseProjectConfirmDialog from "./CloseProjectConfirmDialog";
import ShowChecklistProjectConfirmDialog from "./ChecklistProjectNAConfirmDialog";
import {projectStatusCodeMap} from "../../components/ProjectStatusCodeMap";
import Spinner, { spinnerOff, spinnerOn} from "../../components/Spinner";
import {
    isCreatorOrAdministrator,
    isCreatorOrAdministratorOrInternalContributor,
    isViewOnly, isViewOnlyOrExternalView
} from "../../utils/UserInfo";
import UndoPopUp from "../../components/UndoPopUp";
import PdfReport from "../common/pdf";


class ActiveReview extends Component {
    constructor(props) {
        super(props);
        this.handleExit = this.handleExit.bind(this);
        this.handleEditProject = this.handleEditProject.bind(this);
        this.handleEditTeam = this.handleEditTeam.bind(this);
        this.handleCloseProject = this.handleCloseProject.bind(this);
        this.handleViewAsset = this.handleViewAsset.bind(this);
        this.closeErrorBox = this.closeErrorBox.bind(this);
        this.closeProject = this.closeProject.bind(this);
        this.checklistNAProject = this.checklistNAProject.bind(this);
    }

    state = {
        error : null,
        validationMsg: []
    };

    handleEditProject() {
       this.props.history.push(`/active/${this.props.project.id}/details`);
    }
    handleEditTeam(){
        this.props.history.push(`/active/${this.props.project.id}/team`);
    }
    handleViewAsset() {
        this.props.history.push(`/active/${this.props.project.id}/assetsummary`);
    }
    async saveAndRedirect(projStatus) {
        const {
            setStep,
            setActiveProject,
            setLaunchDashboard,
            setActiveDashboardTab,
            setRefreshNotifications
        } = this.props.context;
        const newAttributes = {
            workOrder: this.state.workOrder || this.props.project.workOrder,
            commissionStartDate:
                this.state.commisionStartDate || this.props.project.commisionStartDate,
            projectStatus: projStatus
        };


        const updatedProject = {
            ...this.props.project,
            ...newAttributes
        };
        spinnerOn();
        await updateProject(updatedProject);
        spinnerOff();
        setActiveProject(updatedProject);
        setRefreshNotifications(true);
        setActiveDashboardTab(projStatus);
        setStep(9);
        setLaunchDashboard(true);

    }

    /**
     * Exit project Overview and set to "Active".
     */
    async handleExit() {
        this.props.history.push(`/dashboard/active`);
    }
    /**
     *Set Closed and set to "Active Tab". TODO change to close tab when built
     */
    handleCloseProject = async () => {
        const {
            setActiveProject,setRefreshNotifications
        } = this.props.context;
        const newAttributes = {
            projectStatus: projectStatusCodeMap["CLOSED"]
        };
        const updatedProject = {
            ...this.props.project,
            ...newAttributes
        };
        await updateProject(updatedProject);
        setActiveProject(updatedProject);
        setRefreshNotifications(true);
        this.props.history.push(`/dashboard/closed`);
    }

    async closeProject() {
        this.setState({error: null});
        this.setState({validationMsg:[]});
        spinnerOn();
        const validateTasks = await validateProjectClose(this.props.project.id);
        spinnerOff();
        const isValid = (validateTasks.assetTasksComplete && validateTasks.projectTasksComplete && validateTasks.formTasksComplete
            && validateTasks.allAssetsAssignedToForm && validateTasks.approvalsComplete && validateTasks.exceptionsClosed
            && validateTasks.formsEnergized && validateTasks.verifyUnResolvedAssets);


            if(!validateTasks.assetTasksComplete)
            {
                this.state.validationMsg.push(<li style={{ color: 'red' }}>Asset Tasks are Incomplete.</li>);
            }
            else{
                this.state.validationMsg.push(<li>Asset Tasks are Complete.</li>);
            }
            if(!validateTasks.projectTasksComplete)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Project Tasks are Incomplete.</li>);
            }
            else{
                this.state.validationMsg.push(<li>Project Tasks are Complete.</li>);
            }
            if(!validateTasks.formTasksComplete)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Pre-Energization Tasks are Incomplete.</li>);
            }
            else{
                this.state.validationMsg.push(<li>Pre-Energization Tasks are Complete.</li>);
            }
            if(!validateTasks.allAssetsAssignedToForm)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Assets are not associated to Pre-Energization Form.</li>);
            }
            else{
                this.state.validationMsg.push(<li>All Assets are associated to Pre-Energization Form.</li>);
            }
            if(!validateTasks.approvalsComplete)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Energization Exception Approvals are pending.</li>);
            }
            else{
                this.state.validationMsg.push(<li>All Energization Exceptions are either Approved, Denied or Cancelled.</li>);
            }
            if(!validateTasks.exceptionsClosed)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Energization Exceptions are open.</li>);
            }
            else{
                this.state.validationMsg.push(<li>All Approved or Denied Energization Exceptions are Closed.</li>);
            }
            if(!validateTasks.formsEnergized)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>Pre-Energization Forms are not set to Energized.</li>);
            }
            else{
                this.state.validationMsg.push(<li>All Pre-Energization Forms are Energized.</li>);
            }
            if(!validateTasks.verifyUnResolvedAssets)
            {
                this.state.validationMsg.push(<li  style={{ color: 'red' }}>There are unresolved Assets.</li>);
            }
            else{
                this.state.validationMsg.push(<li>All Assets are verified.</li>);
            }
            if (isValid) {
                this.closeProjectConfirm();
            }
            else{
            confirmAlert({
                title: 'Project Close Validations',
                message: <ul>
                    {this.state.validationMsg}
                </ul>,
                buttons:[{
                    label: 'Ok',
                },]
            });
        }
    }

    /**
     *
     * Set project to Checklist NA and go back to the Active Tab
     */

    async checklistNAProject() {
        this.setState({error: null});
        this.checkListNAProjectConfirm();
    }

    checkListNAProjectConfirm = () => {
        ShowChecklistProjectConfirmDialog(this.props.project, this.props.history, this.props.context);
    }


    handleErrors(error){
        this.setState({error});
        window.scrollTo(0,0);
    }

    closeErrorBox(){
        const error = null;
        this.setState({error});
    }

    closeProjectConfirm = () => {
        ShowCloseProjectConfirmDialog({handleCloseProject: (props)=>this.handleCloseProject(props)}, this.state.validationMsg);
    }

    render() {
        return (
            <Grid fluid>
                <Errors error={this.state.error}
                        onCloseBox={this.closeErrorBox} />
                <Spinner/>
                <div className="row">
                    <Review
                        project={this.props.project}
                        onEditProject={this.handleEditProject}
                        onEditTeam={this.handleEditTeam}
                        onViewAsset={this.handleViewAsset}
                        teamMembers={this.props.teamMembers}
                    />
                </div>
                <div className="container-fluid">
                    <Row className="projdtls-button">
                        <Col xs={12} style={{marginLeft: '-15px'}}>
                            { !isViewOnlyOrExternalView() &&
                                <Button
                                    onClickHandler={this.closeProject.bind(this)}
                                >
                                    Close Project
                                </Button>
                            }
                            { isCreatorOrAdministrator() &&
                            <Button
                                onClickHandler={this.checklistNAProject.bind(this)}
                            >
                                Checklist N/A
                            </Button>
                            }
                            { isCreatorOrAdministrator() &&
                            <UndoPopUp
                                project={this.props.project}
                                history={this.props.history}
                                context={this.props.context}
                                undoStatus={"Undo Active Project"}/>
                            }
                             <PdfReport project={this.props.project}/>
                        </Col>
                    </Row>
                </div>
            </Grid>
        );
    }
}

ActiveReview.contextType = CommToolContext;
export default withRouter(ActiveReview);

